import { defineStore } from 'pinia';
import { useAPI } from '~/composables/useAPI';
import { useNuxtApp } from '#app';
export const useProyectosStore = defineStore('proyectos', {

    state: () => ({
        proyectos: null,
        proyecto:null
    }),
    actions: {
        async fetchProyectos() {
            const api = useAPI();
            const { $i18n } = useNuxtApp();
            const data = {"idioma" : $i18n.locale, "categoria":"proyectos"}
            const response = await api.get('articulos', data);
            this.proyectos = response.data;
        },
        async fetchProyecto(alias) {
            const api = useAPI();
            const { $i18n } = useNuxtApp();
            const d3ata = {"idioma" : $i18n.locale, "categoria":"proyectos"}
            const response = await api.get(`articulos/${alias}`, data);
            this.proyecto = response.data;
        },
    },
});
